import * as K from 'common/constants';
import { SortOrder } from 'common/graphqlTypes';

import { View, VIEW_NAME } from 'views/types';

export const standardView: View = {
  name: VIEW_NAME.STANDARD,
  label: 'Unstructured',
  order: 3,
  displaySettings: {
    displayMode: K.DISPLAY_MODE.LINES,
    disableLiveTail: false,
    fontFamily: K.FONT_FAMILY.MONOSPACE,
    searchAllTeamsByDefault: false,
    showChart: true,
    sortOrder: SortOrder.MOST_RECENT_AT_BOTTOM,
  },
  classNames: {
    tableSystemField: 'TableLogResults__Field--System',
  },
};
